import { Route, Routes } from "react-router-dom";
import { PTLI0418001Q } from "../surv/qustnr/PTLI0418001Q";
import { PTLI0419001Q } from "../surv/ques/PTLI0419001Q";
import { PTLI0420001Q } from "../surv/itm/PTLI0420001Q";
import { PTLI0421001Q } from "../surv/rspn/PTLI0421001Q";
import { PTLI0418002S } from "../surv/qustnr/PTLI0418002S";
import { PTLI0419002S } from "../surv/ques/PTLI0419002S";
import { PTLI0421002Q } from "../surv/rspn/PTLI0421002Q";
import { PTLI0418004Q } from "../surv/qustnr/PTLI0418004Q";
import { PTLI0418003S } from "../surv/qustnr/PTLI0418003S";
import { PTLI0420002S } from "../surv/itm/PTLI0420002S";
import { PTLI0419003S } from "../surv/ques/PTLI0419003S";
import { PTLI0419004Q } from "../surv/ques/PTLI0419004Q";
import { PTLI0420003S } from "../surv/itm/PTLI0420003S";
import { PTLI0420004Q } from "../surv/itm/PTLI0420004Q";
import { PTLI0422001Q } from "../surv/ststcl/PTLI0422001Q";
import { PTLI0422002Q } from "../surv/ststcl/PTLI0422002Q";

export const SurvRouter = () => {
    return (
        <Routes>
            {/* Survey Management List !== 설문조사 관리 ==! */}
            <Route path="/qustnr/ptli0418001q" element={<PTLI0418001Q />} />

            {/* Survey Management Registration !== 설문조사 등록 ==! */}
            <Route path="/qustnr/ptli0418002s" element={<PTLI0418002S />} />

            {/* Survey Management Edit !== 설문조사 수정 ==! */}
            <Route path="/qustnr/ptli0418003s/:qestnrId" element={<PTLI0418003S />} />

            {/* Survey Management Detail !== 설문조사 상세 ==! */}
            <Route path="/qustnr/ptli0418004q/:qestnrId" element={<PTLI0418004Q />} />

            {/* Survey Question Management List !== 설문 질문 관리 ==! */}
            <Route path="/ques/ptli0419001q" element={<PTLI0419001Q />} />

            {/* Survey Question Registration !== 설문 질문 등록 ==! */}
            <Route path="/ques/ptli0419002s" element={<PTLI0419002S />} />

            {/* Survey Question Edit !== 설문 질문 수정 ==! */}
            <Route path="/ques/ptli0419003s/:qestnrId/:quesId" element={<PTLI0419003S />} />

            {/* Survey Question Detail !== 설문 질문 상세 ==! */}
            <Route path="/ques/ptli0419004q/:qestnrId/:quesId" element={<PTLI0419004Q />} />

            {/* Survey Item Management !== 설문 항목 관리 ==! */}
            <Route path="/itm/ptli0420001q" element={<PTLI0420001Q />} />

            {/* Survey Item Registration !== 설문 항목 등록 ==! */}
            <Route path="/itm/ptli0420002s" element={<PTLI0420002S />} />

            {/* Survey Question Edit !== 설문 질문 수정 ==! */}
            <Route path="/itm/ptli0420003s/:quesItmId" element={<PTLI0420003S />} />

            {/* Survey Question Detail !== 설문 질문 상세 ==! */}
            <Route path="/itm/ptli0420004q/:quesItmId" element={<PTLI0420004Q />} />

            {/* Survey response Management List !== 설문 응답 결과 관리 ==! */}
            <Route path="/rspn/ptli0421001q" element={<PTLI0421001Q />} />

            {/* Survey reponse Registration !== 설문 응답 결과 관리 ==! */}
            <Route path="/rspn/ptli0421002q/:quesRspnUsrId" element={<PTLI0421002Q />} />

            {/* Survey Statistics List !== 설문 통계 목록 ==! */}
            <Route path="/ststcl/ptli0422001q" element={<PTLI0422001Q />} />

            {/* Survey Statistics Detail !== 설문 통계 상세 ==! */}
            <Route path="/ststcl/ptli0422002q/:qestnrId/:quesCnt" element={<PTLI0422002Q />} />
        </Routes>
    );
};
